import { subscribe } from "klaviyo-subscribe";

const forms = document.querySelectorAll('.js-newsletter');

forms.forEach((form) => {
  form.onsubmit = '';

  const success = form.querySelector('.js-success');
  const error = form.querySelector('.js-error');
  const content = form.querySelector('.js-content');

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    const email = form.querySelector('[name="contact[email]"]').value;

    subscribe(window.theme.klaviyoListId, email).then(response => {
      if (response.success) {
        success.hidden = false;
        error.hidden = true;
        content.hidden = true;
      } else {
        success.hidden = true;
        error.hidden = false;
        content.hidden = false;
      }
    });
  });
});
